<template>
  <td>
    <a v-if="model.user_url" :href="model.user_url">
      {{ content }}
    </a>
    <div v-else>
      {{ content }}
    </div>
  </td>
</template>

<script lang="babel">

export default {
    props: ['model', 'content'],
};
</script>
